import { Textarea } from '@flixbus/honeycomb-react';
import { useEffect, useState } from 'react';
import { useVoucherFormContext } from '../../Context';

const VoucherFormComment = () => {
  const { handleCommentChange, formState } = useVoucherFormContext();
  const [text, setText] = useState('');
  const [touched, setTouched] = useState(false);

  const hasValue = text.trim().length > 0;
  const isValid = !hasValue || (text.length >= 10 && text.length <= 255);
  const showError = touched && !isValid;

  useEffect(() => {
    if (!hasValue) {
      handleCommentChange(null);
    } else {
      handleCommentChange(text);
    }
  }, [text, hasValue, handleCommentChange]);

  return (
    <Textarea
      name='comment-field'
      id='comment-field'
      aria-label='comment-input-field'
      onChange={e => {
        if (!touched) setTouched(true);
        setText(e.target.value);
      }}
      onBlur={() => setTouched(true)}
      valid={!showError}
      infoError='comment must be between 10 and 255 characters to be saved.'
      maxLength={255}
      disabled={formState.payload.count > 1}
    />
  );
};

export default VoucherFormComment;
